import { z } from 'zod';
import { dateSchema } from '../../validation';

/**
 * Saved gateway payment method (tokenized — never raw card data).
 *
 * The token is the long-lived id returned by Moyasar on the first
 * `save_card: true` checkout. Subsequent renewals charge this token via
 * `MoyasarService.chargeToken({ token, ... })`.
 *
 * If a charge fails because Moyasar reports the token as expired/revoked,
 * the consumer flow re-prompts the user to add a new card. The old token
 * is replaced; we never store multiple active tokens per Subscription.
 */
export const subscriptionPaymentMethodSchema = z.object({
  provider: z.literal('moyasar'),
  token: z.string(),
  last4: z.string().optional(),
  brand: z.enum(['MADA', 'VISA', 'MASTER', 'AMEX']).optional(),
  /** mirror of the cardholder country (`metadata.country` from Moyasar) for fraud reporting */
  country: z.string().optional(),
  savedAt: dateSchema,
});
export type SubscriptionPaymentMethod = z.infer<typeof subscriptionPaymentMethodSchema>;

/** Safe for API responses — never includes the Moyasar token. */
export const subscriptionPaymentMethodPublicSchema = subscriptionPaymentMethodSchema.omit({
  token: true,
});
export type SubscriptionPaymentMethodPublic = z.infer<
  typeof subscriptionPaymentMethodPublicSchema
>;
